import {
  ModifiedMyNumber,
  MyNumber,
  RefkeyGenerator,
} from "@graffer-inc/cloud-gov-core";
import { MyNumberRefKeyExchanger } from "@graffer-inc/form-schema";
import apiClient from "../../apis/api-client";

export type ModifyingMyNumber = MyNumber & {
  value: string;
  isModified: boolean;
  myNumber?: string;
  myNumberId?: string;
  last4Digit?: string;
  requestDecrypt?: (refKey: string) => Promise<string>;
};

export class ModifyMyNumberExchanger implements MyNumberRefKeyExchanger {
  constructor(
    private applicationId: string,
    private registry: { [key: string]: ModifyingMyNumber },
  ) {}

  clearRefKey(_: string): void {
    // 訂正時は「元に戻す」操作の為に、registryにデータは残しておく
    // delete this.registry[prevRefKey];
  }

  getRegistry(): { [key: string]: ModifyingMyNumber } {
    return {
      ...this.registry,
    };
  }

  getRegistryItems(): ModifiedMyNumber[] {
    return Object.keys(this.registry).map((k) => {
      const target = this.registry[k];
      if (target.isModified) {
        return {
          refKey: target.refKey,
          myNumber: target.myNumber,
        };
      } else {
        return {
          refKey: target.refKey,
          myNumberId: target.myNumberId,
          last4Digit: target.last4Digit,
        };
      }
    });
  }

  refkeyToValue(refkey: string) {
    const myNumber = this.registry[refkey];
    const isModified = !myNumber.myNumberId;
    return {
      value: refkey,
      isModified: isModified,
      myNumber: myNumber.myNumber,
      requestDecrypt: !isModified
        ? async (ref: string) => {
            const { data } = await apiClient.fetchApplicationMyNumber(
              this.applicationId,
              ref,
            );
            return data.myNumber;
          }
        : undefined,
    };
  }

  valueToRefkey(value: string, prevRefKey?: string): string {
    const key =
      prevRefKey ||
      RefkeyGenerator.generateUniqueMyNumberRefKey(Object.keys(this.registry));
    this.registry = {
      ...this.registry,
      [key]: {
        refKey: key,
        value: value,
        isModified: true,
        myNumber: value,
      },
    };
    return key;
  }
}
